import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=e349aba4&scoped=true&"
import script from "./pay.vue?vue&type=script&lang=js&"
export * from "./pay.vue?vue&type=script&lang=js&"
import style0 from "./pay.vue?vue&type=style&index=0&id=e349aba4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e349aba4",
  null
  
)

export default component.exports